import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: [],
};

export default function fundDetailsImportReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_FUND_DETAILS_IMPORT_INIT:
      return { ...state, error: null, isLoading: true };

    case types.GET_FUND_DETAILS_IMPORT_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_FUND_DETAILS_IMPORT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    case types.GET_FUND_DETAILS_IMPORT_FAILURE_CLEAR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
}
